// @ts-nocheck
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'components/grid/table/styled';
import { renderChildren } from 'utils/react';
import { isFunction, noop } from 'lodash';

class FieldComponent extends Component<any> {
  static propTypes = {
    align: PropTypes.string,
    children: PropTypes.func,
    className: PropTypes.string,
    data: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    onRowClick: PropTypes.func,
    onClick: PropTypes.func,
    rowNumber: PropTypes.number,
    columnNumber: PropTypes.number,
    value: PropTypes.any,
    defaultValue: PropTypes.string,
    zIndex: PropTypes.number,
    transformValue: PropTypes.func,
    bold: PropTypes.bool,
    upperCase: PropTypes.bool,
  };

  static defaultProps = {
    align: 'center',
    children: undefined,
    className: undefined,
    data: {},
    name: '',
    label: '',
    onRowClick: noop,
    onClick: noop,
    rowNumber: undefined,
    columnNumber: undefined,
    value: undefined,
    defaultValue: '-',
    zIndex: undefined,
    transformValue: (value) => value,
    bold: false,
    upperCase: false,
  };

  /*
    // TODO see if we can optimize renders
    shouldComponentUpdate(props) {
        const check = ['value', 'sorted'];
        return notEqual(pick(this.props, check), pick(props, check));
    }
    */

  onClick = (event) => {
    event.persist();
    this.props.onRowClick();
    this.props.onClick(event, this.props.value);
  };

  render() {
    const {
      align,
      children,
      className,
      data,
      rowNumber,
      columnNumber,
      name,
      defaultValue,
      zIndex,
      transformValue,
      onRowClick,
      ...props
    } = this.props;

    const value = transformValue(this.props.value);

    const content = isFunction(children)
      ? renderChildren(children, { data, value, defaultValue })
      : value;

    const fieldValue = [null, undefined].includes(content)
      ? defaultValue
      : content;

    return (
      <Field
        {...props}
        align={align}
        zIndex={zIndex}
        className={className}
        onClick={this.onClick}
        $onRowClick={onRowClick}
        rowNumber={rowNumber}
        data-type={['field', columnNumber, rowNumber + 1]
          .filter(Boolean)
          .join('-')}
        data-field-name={name}
        data-field-value={fieldValue}>
        {fieldValue}
      </Field>
    );
  }
}

export default FieldComponent;
